export const streamKeysToCvent = {
  'Type your message': 'SessionChat-Placeholder-SendChat',
  'Edit Message': 'SessionChat-ChatMessage-Button-Edit',
  Cancel: 'SessionChat-EditMessage-Button-Cancel',
  Delete: 'SessionChat-DeleteMessage-Button-Delete',
  Send: 'SessionChat-EditMessage-Button-Save',
  'Error · Unsent': 'SessionChat-MessageError-NotSent',
  'Message Failed · Click to try again': 'SessionChat-MessageError-NotSent',
  'Message failed. Click to try again.': 'SessionChat-MessageError-NotSent',
  'New Messages!': 'SessionChat-Toast-NewMessages',
  'Attach files': 'Chat-Tooltip-AttachFiles',
  '🏙 Attachment...': 'Chat-Tooltip-UploadAttachment',
  'Connection failure, reconnecting now...': 'SessionChat-Error-LostConnection',
  'Open emoji picker': 'SessionChat_AltText_SelectEmoji',
  'Close emoji picker': 'SessionChat_Tooltip_CloseEmojiPicker',
  'Pick your emoji': 'SessionChat_AriaLabel_EmojiPicker',
  // Attendee messaging-specific keys
  Delivered: 'AttendeeMessaging-MessageTooltip-Delivered',
  'Message Failed · Unauthorized':
    'AttendeeMessaging-MessageError-Unauthorized',
  'Message deleted': 'AttendeeMessaging-ChannelList-MessageDeleted',
  New: 'AttendeeMessaging-MessageList-NewMessage',
  'Nothing yet...': 'AttendeeMessaging-ChannelList-NoMessage',
  Search: 'AttendeeMessaging-Placeholder-EmojiPickerSearch',
  'This message was deleted...': 'AttendeeMessaging-MessageList-DeletedMessage',
  replyCount_other: 'Chat-Replies',
  replyCount_one: 'Chat-Reply',
  Thread: 'Chat-Thread-Header-Title',
  '{{ imageCount }} more': 'Chat-Image-Count-Text',
  Flag: 'Community-Safety-Reporting-MenuOption-ReportPost'
};
